var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2GisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 21,
    viewBox: "0 0 77 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5704 21C16.4069 21 21.1819 16.296 21.1819 10.5C21.1819 4.704 16.4069 0 10.5704 0C4.7129 0 -0.0410461 4.704 -0.0410461 10.5C-0.0410461 16.296 4.7129 21 10.5704 21Z",
    fill: "#299400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5705 3.28134C14.2181 3.28134 16.694 6.05962 16.694 9.0565C16.694 10.2596 16.4287 11.3096 15.8097 12.6222C12.1841 12.6222 11.521 15.0066 11.3662 16.6036L11.2556 17.7191L9.8853 17.7188L9.77467 16.6033C9.61993 15.0063 8.95684 12.6219 5.33122 12.6219C4.71224 11.3093 4.44687 10.2593 4.44687 9.05617C4.44687 6.05929 6.92277 3.28101 10.5705 3.28101V3.28134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7323 3.28125C27.2835 3.28125 24.6969 5.35942 24.719 8.96878H27.9248C27.8807 7.5249 28.8092 6.12501 30.7323 6.12501C32.1915 6.12501 33.12 7.08738 33.12 8.31265C33.12 9.58125 32.1029 10.2814 30.4669 11.0688C28.3226 12.097 27.0402 12.5781 24.719 13.3437L24.7193 17.5001H36.2148V14.6563H29.0522C30.1601 14.1996 31.239 13.6973 32.2136 13.2346C34.8001 12.0096 36.3255 10.6316 36.3255 8.15953C36.3255 5.18448 34.0705 3.28125 30.7323 3.28125ZM41.2997 6.34361H47.9319V3.49985H38.2048V17.4997L41.2997 17.5001V6.34361ZM52.5742 3.49985H49.4794V17.4997L52.5522 17.5001L58.3222 8.55308V17.5001H61.4174V3.49985H58.3222L52.5742 12.4468V3.49985ZM76.9586 12.2501H73.7531C73.2668 13.8031 71.7856 14.8752 70.0389 14.8752C67.4965 14.8752 65.8384 12.7098 65.8384 10.5003C65.8384 8.29083 67.4524 6.12534 70.1272 6.12534C71.8959 6.12534 73.2665 7.19717 73.7528 8.75051L76.9586 8.74985C76.4944 5.62168 73.9961 3.28125 70.0389 3.28125C65.662 3.28125 62.7439 6.32179 62.7439 10.5C62.7439 14.6781 65.662 17.7187 70.0393 17.7187C73.9964 17.7187 76.4947 15.4219 76.959 12.2501H76.9586Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2GisLogo);
export default __webpack_public_path__ + "static/media/2gis-logo.4db0c5e8f3ca334de375749de10413a7.svg";
export { ForwardRef as ReactComponent };